import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { appointementDealersByCar , carInfo } from "../actions/appointement";

const unactiveCar = {
  opacity: 0.5
};
const clickedCar = {
  opacity: 1
};
const unactiveBtnStyle = {
  borderColor: "#f4bca4",
  color:"#f4bca4",
  background: "#fff",
  cursor: "default"
};

class ClassCar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);
    this.state = {
      isActive: null,
      isClicked:null,
      formValidate:false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleClick(index) {
      this.setState({
        isActive: index,
        isClicked:index,
        formValidate:true,
      });
      console.log(this.state);
      this.props.carInfo(this.props.restIntel.intel.dealers[index].label);
  }
  handleSubmit(){
    var index = this.state.isClicked;
    if(index!=null){
      this.props.appointementDealersByCar(index);
      //TRACKING
      var values = {};
      var type = this.props.inquires.home.type;
      values.eventName = "model-choice";
      if(this.props.inquires.home.type=="achat") {
        this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchase-intent'] = "Less than a month" : values['purchase-intent'] = this.props.inquires[type]['purchaseTime']['leadName'];
        values['financing'] = this.props.inquires[type]['financing'];
        values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
        values['licenseRegistration'] = "";
      }
      this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
      this.props.inquires[type]['appointment']==null ? values['prefence'] = "" : values['prefence'] = this.props.inquires[type]['appointment'];
      values.modelChoice = this.props.restIntel.intel.dealers[index].label;
      var iframeData = ["setData", values];
      console.log('iframeData :'+ iframeData );
      window.top.postMessage(iframeData , '*');
      console.log(values);
    }
  }
  onMouseEnterHandler(i) {
    this.setState({
      isActive: i,
    });
  }
  onMouseLeaveHandler() {
    this.setState({
      isActive: null,
    });
  }
  componentDidMount(){
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/model_choice'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
  }
  render() {
    var cars = this.props.restIntel.intel.dealers;
    var carsRender = Object.keys(cars).map(i => {
      return (
        <div
          key={'pageCarElement_'+i}
          className={this.state.isClicked === i ? "clicked pageCarElement move_4_ease" : "pageCarElement move_4_ease" }
          onClick={() => this.handleClick(i)}
          onMouseEnter={() => this.onMouseEnterHandler(i)}
          onMouseLeave={() => this.onMouseLeaveHandler()}
          style={this.state.isActive === i || this.state.isActive === null  ? null : unactiveCar }
        >
          <div className="pageCarButton" key={'pageCarButton_'+i}>
            <div className="contentCar"><img alt={cars[i].label} className="pageCarImg" src={cars[i].icon} key={'pageCarImg_'+i}/></div>
            <div className="pageCarText colorBlack fontBold" key={'pageCarText_'+i}>
              {cars[i].label}
            </div>
          </div>
        </div>
      );
    });
    return (
      <div>
        <div className="moduleMainBodyIntel">
          <div className="pageCarContent">{carsRender}</div>
        </div>
        <button
        disabled={!this.state.formValidate}
        style={this.state.formValidate ? null : unactiveBtnStyle}
        className="pageCta fontMedium colorBlack" onClick={this.handleSubmit}>
          Continuer
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      appointementDealersByCar,
      carInfo
    },
    dispatch
  );

export const PageCar = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassCar);



// WEBPACK FOOTER //
// ./src/containers/PageCar.js